import Change from '../changes/change.entity';
import ChangeEpisodicItem from '../change-episodic-items/change-episodic-item.entity';
import CmWrapBoxEpisodicItem from '../cm-wrap-box-episodic-items/cm-wrap-box-episodic-item.entity';
import { SosUpdateResponse } from '../sos-response';
import { ProdBaseESDoc } from '../types';
import EpisodicItem from '../episodic-items/episodic-item.entity';

export interface ChangeESDoc extends ProdBaseESDoc {
	change_num: string;
	char_first_name: string;
	char_last_name: string;
	description: string;
	episode_num: string;
	char_num: string;
}

export interface ChangeUpdateResponse extends SosUpdateResponse {
	updated: {
		Change: Change[];
		CmWrapBoxEpisodicItem: CmWrapBoxEpisodicItem[];
	};
	listed?: {
		ChangeEpisodicItem: ChangeEpisodicItem[];
		EpisodicItem: EpisodicItem[];
	};
	created: {
		CmWrapBoxEpisodicItem: CmWrapBoxEpisodicItem[];
	};
	destroyed: {
		CmWrapBoxEpisodicItem: CmWrapBoxEpisodicItem[];
	};
}
